<template>
  <div class="recharge_left capital_first">
    <el-row class="headerTopBg" style="align-items: center; display: flex">
      <el-col :span="12">
        <h3>{{$t('header.myAccount')}}</h3>
      </el-col>
      <el-col :span="12" style="text-align: right">
        <div class="content-flex">
          <el-button
            size="mini"
            type="danger"
            style="background-color: #E1B87C; border-color: #E1B87C; padding: 10px 20px;"
            @click="getServerUrl()"
            >{{$t('home.customerService')}}</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-row class="headerTopBg">
      <el-tabs
        @tab-click="handleClick"
        v-model="activeName"
        id="rechargeWithTab"
      >
        <el-tab-pane name="recharge">
          <span slot="label"
            >{{$t('logs.recharge')}}
            <!-- <i class="el-icon-coin" /> -->
          </span>
          <el-card class="box-card" shadow="never">
            <el-row>
              <el-col :span="12" :offset="1">
                <el-form ref="form" label-width="100px" size="small">
                  <el-form-item prop="money" id="amountInput">
                    <span slot="label" class="weigth">{{$t('capital.rechargeAmount')}}:</span>
                    <el-input
                      type="text"
                      v-model="recharge.number"
                      :placeholder="$t('capital.fillRechargeAmount')"
                      onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                      onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                    />
                  </el-form-item>
                  <el-row v-for="(item, index) in auto_fill_amounts" :key="index" style="margin-left: 100px;">
                      <el-col :span="6" v-for="(item1, index1) in item" :key="index1">
                        <el-button round size="large" @click="handleAmount(item1)"  style="border-color: #ff0000; color: #ff0000; margin-bottom: 10px; background: #ffffff;">{{ item1 }}元</el-button>
                      </el-col>
                    </el-row>
                  <el-form-item>
                    <span class="weigth" slot="label">{{$t('capital.rechargeAmountBottom')}}:</span>
                    <el-radio-group v-model="radio" size="medium" id="types">
                      <el-radio
                        v-for="(item, index) in rechargeType"
                        :key="index"
                        :label="index"
                        border
                        class="rechargeRadio"
                        @change="changeInstructions(index)"
                        ><i class="el-icon-bank-card"></i>{{ item.name }}
                      </el-radio>
                      <!--                      <el-radio label="3" border style="width: 100%;margin: 0"><i class="el-icon-bank-card"></i>银行卡人工入款通道(100元-200万元)</el-radio>-->
                    </el-radio-group>
                  </el-form-item>

                  <h4
                    v-if="maxCouponCheck"
                    style="
                      margin: 20px 0;
                      font-size: 14px;
                      color: #626066;
                      padding-left: 100px;
                    "
                  >
                    {{$t('capital.rechargeFull')}}{{ coupounAmount * 10 }}{{$t('userCoupon.deliver')}}{{
                      coupounAmount
                    }}
                    {{$t('userCoupon.validity')}}{{ effectiveDate }}
                  </h4>

                  <el-form-item>
                    <!--                    <el-button type="primary" >取消充值</el-button>-->
                    <el-button
                      type="danger"
                      @click="rechargeNext"
                      :disabled="disabled4"
                      style="
                        width: 100%;
                        background-color: var(--baseColor);
                        border-color: var(--baseColor);
                      "
                      >{{$t('recharge.nextStep')}}
                    </el-button>
                  </el-form-item>
                  <p style="margin-left: 125px; font-size: 14px">
                    {{$t('capital.rechargeObtainCard')}}
                  </p>
                  <h4 style="margin: 20px 0; width: 600px">
                    <div style="padding-left: 27px" v-html="notice_1_1"></div>
                  </h4>
                </el-form>
              </el-col>
            </el-row>
          </el-card>
          <br />
          <el-card class="box-card" shadow="never">
            <div v-html="data"></div>
            <!--<div class="assist">
              <p class="red">活动专区:</p>
              <p class="red">新会员首次充值 巨额返现 可提现</p>
              <table>
                <tr>
                  <th>新会员首冲额(须配资)</th>
                  <th>返现金额(可提现)</th>
                </tr>
                <tr>
                  <td>1000元</td>
                  <td>188元</td>
                </tr>
                <tr>
                  <td>5000元</td>
                  <td>466元</td>
                </tr>
                <tr>
                  <td>10000元</td>
                  <td>888元</td>
                </tr>
                <tr>
                  <td>50000元</td>
                  <td>4666元</td>
                </tr>
                <tr>
                  <td>10万元以上</td>
                  <td>8888元</td>
                </tr>
              </table>
              <p>提示:</p>
              <p>首冲须全额配资后提现,可分次累计</p>
              <p>若首冲不配资,向客服申请扣减返现后,可提现</p>
              <p class="red">任何会员推荐新会员首次充值 推荐人同样奖励 可提现</p>
              <table>
                <tr>
                  <th>新会员首冲额(须配资)</th>
                  <th>推荐人奖励(满100可提现)</th>
                </tr>
                <tr>
                  <td>100-999元</td>
                  <td>10元</td>
                </tr>
                <tr>
                  <td>1000元</td>
                  <td>88元</td>
                </tr>
                <tr>
                  <td>5000元</td>
                  <td>466元</td>
                </tr>
                <tr>
                  <td>10000元</td>
                  <td>888元</td>
                </tr>
                <tr>
                  <td>50000元</td>
                  <td>4666元</td>
                </tr>
                <tr>
                  <td>10万元以上</td>
                  <td>8888元</td>
                </tr>
              </table>
              <p>提示:</p>
              <p>新会员首冲若不配资而提现,推荐人奖励将被自动扣减</p>
              <p class="red">双方受益 利人利己</p>
              <p>本次活动有效期和最终解释权归属大牛证券所有</p>
            </div>-->
          </el-card>
          <br />
          <!--<el-card class="box-card" shadow="never">
            <div class="assist">
              <p class="red">到账时间:</p>
              <p>09:00-17:30(5-30分钟到账)</p>
              <p>17:30以后或节假日(下个开市日09:00前到账)</p>
            </div>
          </el-card>-->
        </el-tab-pane>
        <el-tab-pane name="withdraw">
          <span slot="label"
            >{{$t('agencyPc.withdraw')}}
            <!-- <i class="el-icon-bank-card"></i> -->
          </span>
          <el-card class="box-card" shadow="never">
            <el-row>
              <el-col :span="12" :offset="1">
                <el-form
                  ref="form"
                  :model="withdrawalData"
                  label-width="100px"
                  size="small"
                  style="width: 650px;"
                >
                  <el-form-item label-width="0">
                    <h3>
                      {{$t('agencyPc.useYourOwn')}}({{
                        withdrawalData.account
                      }}){{$t('agencyPc.bankCardWithdrawalInName')}}!
                      <el-button
                        class="right"
                        @click="bankCardState = true"
                        style="border: 2px solid var(--baseColor); color: var(--baseColor)"
                        >{{$t('agencyPc.bankCardManagement')}}</el-button
                      >
                    </h3>
                  </el-form-item>
                  <el-form-item>
                    <h4 slot="label">{{$t('agencyPc.bankName')}}:</h4>
                    <p>{{ withdrawalData.name }}</p>
                  </el-form-item>
                  <el-form-item>
                    <h4 slot="label">{{$t('agencyPc.accountOpeningBranch')}}:</h4>
                    <p>{{ withdrawalData.address }}</p>
                  </el-form-item>
                  <el-form-item>
                    <h4 slot="label">{{$t('agencyPc.bankCardNumber')}}:</h4>
                    <p>{{ withdrawalData.card }}</p>
                  </el-form-item>
                  <el-form-item>
                    <h4 slot="label">{{$t('agencyPc.accountName')}}:</h4>
                    <p>{{ withdrawalData.account }}</p>
                  </el-form-item>
                  <br /><br />
                  <el-form-item label-width="0">
                    <h3>
                      {{$t('capital.selectWithdrawalAmount')}}
                      <el-button
                        class="right"
                        @click="withdrawalState = true"
                        style="border: 2px solid var(--baseColor); color: var(--baseColor)"
                        >{{$t('withdraw.modifyWithdrawPassword')}}</el-button
                      >
                    </h3>
                  </el-form-item>
                  <el-form-item>
                    <h4 slot="label">{{$t('agencyPc.accountBalance')}}:</h4>
                    <p>{{ withdrawalData.cash }}{{$t('operateday.yuan')}}</p>
                  </el-form-item>
                  <el-form-item>
                    <h4 slot="label">{{$t('agencyPc.withdrawalAmount')}}:</h4>
                    <div style="display: flex; width: 800px;">
                      <el-input
                        v-model="withdrawalData.money"
                        :placeholder="$t('capital.fillWithdrwalAmount')"
                        style="width: 550px;"
                      ></el-input>
                      <p style="padding-left: 20px;" class="red">{{$t('capital.withdrawl100RMB')}}</p>
                      </div>
                  </el-form-item>
                  <el-form-item>
                    <h4 slot="label">{{$t('agencyPc.withdrawPassword')}}:</h4>
                    <el-input
                      v-model="withdrawalData.password"
                      :placeholder="$t('capital.fillWithdrawalPw')"
                      show-password
                    ></el-input>
                  </el-form-item>

                  <el-form-item v-if="selected_type==2">
                    <h4 slot="label">Gxpay ID:</h4>
                    <el-input
                      type="text"
                      v-model="withdrawalData.gxpay_id"
                      :placeholder="$t('withdrawalData.gxpay_id')"
                        /> 
                      <div class="confirmCheckedBox">
                       <el-checkbox
                         v-model="withdrawalData.confirmChecked"
                         label="已核对确认"
                         size="large"
                       />
                     </div>
                  </el-form-item>
                  <el-form-item>
                      <div style="width: 600px; font-size: 14px; color: rgb(192, 80, 77);">
                        <div v-html="notice_1_10"></div>
                      </div>
                  </el-form-item>
                  <el-row v-for="(item, index) in auto_fill_amounts_withdraw" :key="index" style="margin-left: 100px;">
                     <el-col :span="6" v-for="(item1, index1) in item" :key="index1">
                       <el-button round size="large" @click="handleWithdrawAmount(item1)"  style="border-color: #ff0000; color: #ff0000; margin-bottom: 10px; background: #ffffff;">{{ item1 }}元</el-button>
                     </el-col>
                  </el-row>
                  <el-form-item>
                    <span class="weigth" slot="label">提现方式:</span>
                    <el-radio-group v-model="radioW" size="medium">
                      <el-radio
                        v-for="(item, index) in withdraweType"
                        :key="index"
                        :label="index"
                        border
                        class="withdrawRadio"
                        @change="changeWithdrawInstructions(index)"
                        ><i class="el-icon-bank-card"></i>{{ item.name }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      type="danger"
                      @click="withdraw_has"
                      style="
                        background-color: var(--baseColor);
                        border-color: var(--baseColor);
                        width: 100%;
                      "
                      >{{$t('withdraw.confirmWithdraw')}}</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </el-card>
          <br />
          <el-card class="box-card" shadow="never">
            <div class="assist">
              <div
                style="padding: 10px 16px; font-size: 13px"
                v-html="withraw_data"
              ></div>
              <!-- <el-row v-if="withdraw_fee_percentage ==0 && withdraw_fee_min ==0">
              </el-row>
              <el-row v-else>
                <el-col :span="24">
                   <p><span style="color: rgb(192, 0, 0);">温馨提醒：</span><br>
                   提现手续费按提现金额的{{withdraw_fee_percentage}}%收取，{{withdraw_fee_min}}元起</p>
                </el-col> -->
              <!-- <el-col :span="8">
                  <div>
                    <h4>闪电到账</h4>
                    <p>最快10分钟到账</p>
                    <p>安全 快捷</p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div>-->
              <!--<h4>提现<span class="red">0</span>手续费</h4>
                    <p>提现产生的银行手续费全免</p>
                    <p>更多优质服务只在大牛证券配资平台官网</p> -->
              <!-- <h4>提现低手续费</h4>
                    <p>根据交易通道不同实行差别化收费</p>
                    <p>详情请咨询在线客服或专属客服</p>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div>
                    <h4>支持银行多达<span class="red">10</span>多家</h4>
                    <p>推荐您使用工商银行、建设银行</p>
                    <p>招商银行、农业银行提现,到账更快</p>
                  </div>
                </el-col> -->
              <!-- </el-row> -->
            </div>
          </el-card>
        </el-tab-pane>
        <!--<el-tab-pane>
          <span slot="label"><i class=" el-icon-copy-document"></i> 划转</span>
          <el-card class="box-card" shadow="never">
            <div class="assist">
              <el-row>
                <el-col :span="12" :offset="1">
                  <el-form ref="form" :model="recharge" label-width="100px" size="small">
                    <el-form-item>
                      <h4 slot="label">从代理账户:</h4>
                      <p>2100.00元</p>
                    </el-form-item>
                    <el-form-item>
                      <h4 slot="label">到本金账户:</h4>
                      <p>90000.00元</p>
                    </el-form-item>
                    <el-form-item>
                      <h4 slot="label">划转金额:</h4>
                      <el-input v-model="recharge.money" placeholder="请填写划转金额"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="danger">账户划转</el-button>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
            </div>
          </el-card>
          <br>
          <el-card class="box-card" shadow="never">
            <div class="assist">
              <h4>划转即刻到账 无任何手续费</h4>
            </div>
          </el-card>
        </el-tab-pane>-->
      </el-tabs>
    </el-row>
    <!-- ============================== Start change channel popup ========================== -->
    <el-dialog
      :visible.sync="showTradeChannelPopup"
      width="40%"
      center
      :before-close="handleTradePopupClose"
    >
      <div v-html="trade_rules_content_top"></div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="agreeTradeRules()"
          style="background-color: var(--baseColor);border-color:var(--baseColor); width: 200px"
          >{{$t('recharge.understand')}}
        </el-button>
        <div
          v-html="trade_rules_content_bottom"
          style="padding-top: 10px"
        ></div>
      </span>
    </el-dialog>
    <!-- ============================== end change channel popup ========================== -->

    <!--    银行卡管理列表-->
    <el-dialog :title="$t('agencyPc.bankCardManagement')" :visible.sync="bankCardState">
      <el-table :data="bankCardList">
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column property="card" :label="$t('capital.cardNumber')"></el-table-column>
        <el-table-column property="name" :label="$t('agencyPc.bankName')"></el-table-column>
        <el-table-column property="address" :label="$t('agencyPc.accountOpeningBranch')"></el-table-column>
        <el-table-column :label="$t('stock.operate')">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              style="background-color: var(--baseColor);border-color:var(--baseColor)"
              @click="handleBankCard(scope.row)"
              >{{$t('stock.sure')}}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      :title="$t('capital.rechargeChannel')"
      :close-on-click-modal="false"
      :visible.sync="topUpStatus"
      width="800px"
    >
      <el-form ref="form" label-width="100px">
        <el-button
          size="mini"
          type="danger"
          style="position: absolute; right: 49px; top: 20px; border-radius: 5px;background-color: var(--baseColor); border-color: var(--baseColor)"
          @click="getServerUrl()"
          >{{$t('account.onlineService')}}</el-button
        >
        <!-- <div v-if="recharge.type == '8'">
          <el-form-item>
            <span class="weigth" slot="label">付款金额:</span>
            <p>联系在线客服<el-button type="text" class="right" @click="handleCopy(companyBank.name)">复制</el-button></p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">账户名称:</span>
            <p>联系在线客服<el-button type="text" class="right" @click="handleCopy(companyBank.name)">复制</el-button></p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">银行卡号:</span>
            <p>联系在线客服<el-button type="text" class="right" @click="handleCopy(companyBank.card)">复制</el-button></p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">银行名称:</span>
            <p>联系在线客服<el-button type="text" class="right" @click="handleCopy(companyBank.bank)">复制</el-button></p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">银行地址:</span>
            <p>联系在线客服<el-button type="text" class="right" @click="handleCopy(companyBank.address)">复制</el-button></p>
          </el-form-item>
          <div class="hint">
            <h3 class="red">温馨提示：</h3>
            <p>若10分钟内若未入款，请联系在线客服或专属客服。</p>
          </div>
        </div> -->
        <div v-if="recharge.type == '3'">
          <div class="notice-hint">
            <div v-html="notice_2_1"></div>
            <!-- <p>充值须知：</p>
            <p>1、请每一次充值必须获取最新帐号，以免充值无效。</p>
            <p>2、请必须使用本人帐号充值，避免查不到账。</p>
            <p>3、转账成功后点“我已转账，申请充值”，平台确认后到账。</p>
            <p>4、单笔充值请勿超过4.5万，充值4.5万以上请联系客服申请大额充值帐户。</p>
            <p>5、单笔充值20万以上，请提前一天联系客服申请vip充值帐户。</p> -->
          </div>
          <el-form-item>
            <span class="weigth" slot="label">{{$t('capital.paymentAmount')}}:</span>
            <p>
              {{ recharge.number }}{{$t('operateday.yuan')}}
              <el-button
                type="text"
                class="right"
                @click="handleCopy(companyBank.name)"
                >{{$t('rechargeInfo.copy')}}</el-button
              >
            </p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">{{$t('agencyPc.accountName')}}:</span>
            <p>
              {{ companyBank.name }}
              <el-button
                type="text"
                class="right"
                @click="handleCopy(companyBank.name)"
                >{{$t('rechargeInfo.copy')}}</el-button
              >
            </p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">{{$t('agencyPc.bankCardNumber')}}:</span>
            <p>
              {{ companyBank.card }}
              <el-button
                type="text"
                class="right"
                @click="handleCopy(companyBank.card)"
                >{{$t('rechargeInfo.copy')}}</el-button
              >
            </p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">{{$t('capital.bankBranch')}}:</span>
            <p>
              {{ companyBank.bank }}
              <el-button
                type="text"
                class="right"
                @click="handleCopy(companyBank.bank)"
                >{{$t('rechargeInfo.copy')}}</el-button
              >
            </p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">{{$t('capital.bankAddress')}}:</span>
            <p>
              {{ companyBank.address }}
              <el-button
                type="text"
                class="right"
                @click="handleCopy(companyBank.address)"
                >{{$t('rechargeInfo.copy')}}</el-button
              >
            </p>
          </el-form-item>
          <div class="notice-hint">
            <div v-html="notice_2_2"></div>
            <!-- <h3 class="red">温馨提示：</h3>
            <p>若10分钟内若未入款，请联系在线客服或专属客服。</p> -->
          </div>
        </div>
        <div v-if="recharge.type == '6'">
          <div class="notice-hint">
            <div v-html="notice_2_1"></div>
            <!-- <p>充值须知：</p>
            <p>1、请勿保留旧卡转账，会造成无法充值。</p>
            <p>2、请用本人账号自行通过手机/电脑/银行向以下账号转账。</p>
            <p>3、转账成功后点“我已转账，申请充值”，平台确认后到账。</p>
            <p>4、转账金额须与系统一致，若有小数须带小数，否则次日到账。</p> -->
          </div>
          <el-form-item>
            <span class="weigth" slot="label">{{$t('capital.paymentTime')}}:</span>
            <p>
              {{$t('capital.pleaseAt')}}<span class="red">{{ time.endTime }}</span
              >{{$t('capital.paidBefore')}}
            </p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">{{$t('capital.paymentAmount')}}:</span>
            <p>
              <span class="red">{{ companyBank.money }}{{$t('operateday.yuan')}}</span
              >{{$t('capital.msgAboutAmount')}}
              <el-button
                type="text"
                class="right"
                @click="handleCopy(companyBank.money)"
                >{{$t('rechargeInfo.copy')}}</el-button
              >
            </p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">{{$t('capital.accNameOther')}}:</span>
            <p>
              {{ companyBank.name }}
              <el-button
                type="text"
                class="right"
                @click="handleCopy(companyBank.name)"
                >{{$t('rechargeInfo.copy')}}</el-button
              >
            </p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">{{$t('agencyPc.bankCardNumber')}}:</span>
            <p>
              {{ companyBank.card }}
              <el-button
                type="text"
                class="right"
                @click="handleCopy(companyBank.card)"
                >{{$t('rechargeInfo.copy')}}</el-button
              >
            </p>
          </el-form-item>
          <el-form-item>
            <span class="weigth" slot="label">{{$t('agencyPc.bankName')}}:</span>
            <p>
              {{ companyBank.bank }}
              <el-button
                type="text"
                class="right"
                @click="handleCopy(companyBank.bank)"
                >{{$t('rechargeInfo.copy')}}</el-button
              >
            </p>
          </el-form-item>
          <div class="notice-hint">
            <div v-html="notice_2_2"></div>
            <!-- <h3 class="red">温馨提醒：</h3>
            <p>
              1-部分转账带小数是系统快速判断入款的需要，否则次日到账。举例提交100元，系统显示100.02元，请转100.02元即可到账。
            </p>
            <p>2-若10分钟内若未入款，请联系在线客服或专属客服。</p> -->
          </div>

          <!--<el-form-item>
            <p class="red" style="line-height: 1.5">温馨提醒：</p>
            <p class="red" style="line-height: 1.5">1-带小数的准确金额是为了确保您的转账金额的唯一性，系统以此判断区分是您的转账并自动入款，否则转人工审核，次日入款，将严重耽误您的到账时间。</p>
            <p class="red" style="line-height: 1.5">2-10分钟内转账将自动入款，若未入款，请联系在线客服或专属客服处理。</p>
            <p class="red" style="line-height: 1.5">3-请勿保留旧的银行卡号进行交易，否则将会导致资金无法到账，本站概不负责！</p>
          </el-form-item>-->
        </div>
        <div v-if="recharge.type == '7'">
          <iframe
            :src="recharge.url"
            frameborder="0"
            width="100%"
            height="600px"
          ></iframe>

          <!--<el-form-item>
            <p class="red" style="line-height: 1.5">温馨提醒：</p>
            <p class="red" style="line-height: 1.5">1-带小数的准确金额是为了确保您的转账金额的唯一性，系统以此判断区分是您的转账并自动入款，否则转人工审核，次日入款，将严重耽误您的到账时间。</p>
            <p class="red" style="line-height: 1.5">2-10分钟内转账将自动入款，若未入款，请联系在线客服或专属客服处理。</p>
            <p class="red" style="line-height: 1.5">3-请勿保留旧的银行卡号进行交易，否则将会导致资金无法到账，本站概不负责！</p>
          </el-form-item>-->
        </div>
        <div v-if="recharge.type == '8'">
          <div class="notice-hint">
            <div v-html="notice_2_1"></div>
            <!-- <p style="font-size: 16px; font-weight: bold">温馨提示：</p>
            <p style="font-size: 16px; font-weight: bold">自动入款每天限额</p>
            <p style="font-size: 16px; font-weight: bold">
              “多次获取不到银行卡”或者“充值一万以上”
            </p>
            <p style="font-size: 16px; font-weight: bold">
              请您联系在线客服获取最新银行卡。
            </p> -->
          </div>
          <iframe
            :src="recharge.url"
            frameborder="0"
            width="100%"
            height="600px"
          ></iframe>

          <!--<el-form-item>
            <p class="red" style="line-height: 1.5">温馨提醒：</p>
            <p class="red" style="line-height: 1.5">1-带小数的准确金额是为了确保您的转账金额的唯一性，系统以此判断区分是您的转账并自动入款，否则转人工审核，次日入款，将严重耽误您的到账时间。</p>
            <p class="red" style="line-height: 1.5">2-10分钟内转账将自动入款，若未入款，请联系在线客服或专属客服处理。</p>
            <p class="red" style="line-height: 1.5">3-请勿保留旧的银行卡号进行交易，否则将会导致资金无法到账，本站概不负责！</p>
          </el-form-item>-->
        </div>
        <div v-if="recharge.type == '9'">
          <div class="notice-hint">
            <div v-html="notice_2_1"></div>
            <!-- <p style="font-size: 16px; font-weight: bold">温馨提示：</p>
            <p style="font-size: 16px; font-weight: bold">自动入款每天限额</p>
            <p style="font-size: 16px; font-weight: bold">
              “多次获取不到银行卡”或者“充值一万以上”
            </p>
            <p style="font-size: 16px; font-weight: bold">
              请您联系在线客服获取最新银行卡。
            </p> -->
          </div>
          <iframe
            :src="recharge.url"
            frameborder="0"
            width="100%"
            height="600px"
          ></iframe>

          <!--<el-form-item>
            <p class="red" style="line-height: 1.5">温馨提醒：</p>
            <p class="red" style="line-height: 1.5">1-带小数的准确金额是为了确保您的转账金额的唯一性，系统以此判断区分是您的转账并自动入款，否则转人工审核，次日入款，将严重耽误您的到账时间。</p>
            <p class="red" style="line-height: 1.5">2-10分钟内转账将自动入款，若未入款，请联系在线客服或专属客服处理。</p>
            <p class="red" style="line-height: 1.5">3-请勿保留旧的银行卡号进行交易，否则将会导致资金无法到账，本站概不负责！</p>
          </el-form-item>-->
        </div>

        <div v-if="recharge.type == '12'">
          <div class="notice-hint">
            <div v-html="notice_2_1"></div>
            <!-- <p style="color: black; font-size: 19px">
              充值通道 数字货币-USDT(TRC20)
            </p>
            <br />
            <p>充值须知：</p>
            <p>1、重复支付、修改金额充值无法到账，概不负责。</p>
            <p>2、平台以到账数量为准，到账数量=转账数量-转账手续费。</p>
            <p>3、扫描二维码或复制地址充值，仅接受TRC20-USDT。</p> -->
            <br />

            <p
              style="width: 200px; text-align: left; color: black"
              class=""
              slot="label"
            >
              {{$t('rechargeInfo.payCountdown')}}<span id="countDown"></span>
            </p>
            <br />

            <el-form-item>
              <p
                style="
                  width: 200px;
                  text-align: left;
                  color: black;
                  line-height: 20px;
                "
                class=""
                slot="label"
              >
                {{$t('rechargeInfo.payPlease')}}<span style="color: red">{{ crypto.USDTAmount }}</span
                > USDT<br />
                {{$t('rechargeInfo.recieptAmount')}}{{ crypto.money }}{{$t('operateday.yuan')}}<br />
                USDT（TRC20）{{$t('rechargeInfo.rechargeQrCode')}}
              </p>
              <p>
                <el-button
                  type="text"
                  class="right"
                  @click="handleCopy(crypto.USDTAmount)"
                  >{{$t('rechargeInfo.copy')}}</el-button
                >
              </p>
            </el-form-item>
            <div
              style="width: 670px; text-align: left"
              class="hint"
              slot="label"
            >
              <div id="qrcode" class="crypto_qrcode"></div>
            </div>
            <el-form-item>
              <p
                style="width: 400px; text-align: left; color: black"
                class="hint"
                slot="label"
              >
                USDT（TRC20）{{$t('rechargeInfo.rechargeAddress')}}<br />
                {{ crypto.qrCode }}
              </p>
              <el-button
                type="text"
                class="right"
                @click="handleCopy(crypto.qrCode)"
                >{{$t('rechargeInfo.copy')}}</el-button
              >
            </el-form-item>
            <div v-html="notice_2_2"></div>
            <!-- <p class="red">温馨提示：</p>
            <p>请转账后请截图发给在线客服或专属客服确认，申请充值。</p>
            <p>需等待1-15分钟，整个网络节点上有一定确认数后，才会实际到账。</p> -->
          </div>
        </div>

        <!--<div v-if="recharge.type === '1'" class="recharge-img">
          <el-form-item>
            <el-image
              style="width: 200px;"
              :src="ali_pay"
              fit="fit" />
          </el-form-item>
          <el-form-item>
            <p class="red">支付宝扫码后,请点击立即充值</p>
          </el-form-item>
        </div>-->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="topUpStatus = false">{{$t('rechargeInfo.cancelAddress')}}</el-button>
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="onRecharge" :disabled="disabledR"
          >{{$t('rechargeInfo.transferredMoney')}}</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('withdraw.modifyWithdrawPassword')"
      :visible.sync="withdrawalState"
      width="25%"
      :close-on-click-modal="false"
    >
      <el-form>
        <el-form-item id="amountInput">
          <el-row>
            <el-col :span="14">
              <el-input
                v-model="inputPayCode"
                autocomplete="off"
                :placeholder="$t('information.enterVerCode')"
              ></el-input>
            </el-col>
            <el-col :span="10">
              <el-button
                :disabled="disabled3"
                type="info"
                style="width: 100%"
                @click="getPayCode"
                >{{ getPayCodeText }}
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item id="amountInput">
          <el-input
            type="password"
            v-model="inputPayPass"
            :placeholder="$t('information.enterPass')"
          ></el-input>
        </el-form-item>
        <el-form-item id="amountInput">
          <el-input
            type="password"
            v-model="inputPayConf"
            :placeholder="$t('information.enterConfPass')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="emptyPayPass" class="dialog-cancel">{{$t('rechargeau.cancel')}}</el-button>
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="setPayPass">{{$t('rechargeau.sure')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="Recharge_amount"
      width="25%"
      :close-on-click-modal="true"
      id="thirdPartyPopup maxamount"
    >
      <el-form :model="real" style="text-align: center">
        <span style="font-size: 18px; margin-bottom: 1px">{{
          Recharge_Max
        }}</span>
      </el-form>

      <div slot="footer" class="dialog-footer" style="text-align: center;margin-top:30px;">
        <el-button
          style="border: 1px solid grey"
          @click="Recharge_amount = false"
          >{{$t('registerPc.cancel')}}</el-button
        >
      </div>
    </el-dialog>

    <!--    实名认证-->
    <el-dialog
      :title="$t('information.verified')"
      :visible.sync="real.realStatus"
      width="25%"
      :close-on-click-modal="false"
    >
      <el-form :model="real">
        <el-form-item>
          <el-input
            :placeholder="$t('information.enterRealName')"
            v-model="real.inputReal"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            :placeholder="$t('information.enterIdNumber')"
            v-model="real.inputIdcard"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="real.realStatus = false">{{$t('rechargeau.cancel')}}</el-button>
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="setReal">{{$t('rechargeau.sure')}}</el-button>
      </div>
    </el-dialog>

    <!--    绑定银行卡-->
    <el-dialog
      :title="$t('information.bindBankCard')"
      :visible.sync="bank.bankStatus"
      width="25%"
      :close-on-click-modal="false"
    >
      <el-form :model="bank">
        <el-form-item id="amountInput">
          <el-input
            :placeholder="$t('information.enterAccountName')"
            v-model="bank.inputBankName"
            :readonly="realNameEditStatus"
          ></el-input>
        </el-form-item>
        <el-form-item id="amountInput">
          <el-input
            :placeholder="$t('information.enterBankCard')"
            v-model="bank.inputBankCode"
          ></el-input>
        </el-form-item>
        <el-form-item id="amountInput">
          <el-select v-model="bank.bankId" style="width: 100%">
            <el-option
              v-for="(item, index) in bank.bankList"
              :key="index"
              :value="item.id"
              :label="item.bank"
            ></el-option>
          </el-select>
        </el-form-item>
        
        
        <el-form-item id="amountInput">
          <el-input
            :placeholder="$t('information.enterBranchName')"
            v-model="bank.inputBankAccess"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bank.bankStatus = false" class="dialog-cancel">{{$t('rechargeau.cancel')}}</el-button>
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="setBank">{{$t('rechargeau.sure')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";
import QRCode from "qrcodejs2";
import JSEncrypt from "jsencrypt/bin/jsencrypt";
import { version } from "../../package";
import { Loading } from 'element-ui';

export default {
  name: "capital",
  data() {
    return {
      selectedTypeId: "",
      notice_1_1: "",
      notice_2_1: "",
      notice_2_2: "",
      notice_1_10: "",
      cryptoUrl: "",
      //充值用户信息
      recharge: {
        number: "",
        type: "6",
        card: "",
        //实名状态
        realStatus: false,
        url: "",
      },
      radio: 0,
      real: {
        inputReal: "",
        inputIdcard: "",
        realStatus: false,
      },
      //提现用户信息
      withdrawalData: {
        name: "",
        card: "",
        address: "",
        account: "",
        money: "",
        password: "",
        cash: 0,
        bankStatus: false,
        isWithdrawalData: false,
        type: 1,
        id: 1,
        gxpay_id:'',
        confirmChecked: false
      },
      rechargeType: [],
      withdraweType: [],

      //银行卡
      bank: {
        bankId: "",
        inputBankCode: "",
        inputBankName: "",
        inputBankAccess: "",
        bankList: [],
        bankStatus: false,
      },

      recharge_rules: {
        money: [
          { required: true, message: this.$t('capital.enterRechargeAmount'), trigger: "blur" },
          {
            integer: "integer",
            min: 1,
            max: 9999999,
            message: this.$t('capital.enterCorrectAmount'),
            trigger: "blur",
          },
        ],
      },
      companyBank: {},
      //用户银行卡
      bankCardList: [],
      //银行卡管理状态
      bankCardState: false,
      ali_isactive: 0,
      wechat_isactive: 0,
      ali_pay: "",
      we_chat_pay: "",
      topUpStatus: false,
      data: "",
      withdrawalState: false,
      inputPayCode: "",
      getPayCodeText: this.$t('forgotPassword.getVerificationCode'), //
      inputPayPass: "", //支付密码
      inputPayConf: "", //确认密码
      inputLoginPhone: "", //获取手机号
      disabled3: false,
      disabled4: false,
      disabledR: false,
      maxCouponData: "",
      maxCouponCheck: false,
      coupounAmount: 0,
      effectiveDate: "",
      time: {
        endTime: 0,
      },
      activeName: "recharge",
      Recharge_amount: false,
      Recharge_Max: "",
      crypto: {
        money: 0,
        USDTAmount: "",
        qrCode: "",
        endTime: 0,
        rechargeId: 0,
      },
      countDownTime: 1800,
      interVal: "",
      popupStatus: 0,
      timbaoAnulaizedInterestRate: 0,
      timebaoRate: 0,
      trade_channel_status: "",
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      withdraw_fee_percentage: 0,
      withdraw_fee_min: 0,
      withraw_data:"",
      user_realName: '',
      realNameEditStatus: false,
      auto_fill_amounts: [],
       isAutoAmounts:false,

      selectedWithdrawTypeId: "",
      auto_fill_amounts_withdraw: [],
      isAutoAmountsWithdraw:false,
      radioW: 0,
      selected_type:'',
    };
  },
  methods: {
    //充值活动
    getData() {
      let that = this;
      that
        .$http({
          url: "/app/Protocol/protocol",
          method: "post",
          data: {
            type: 19,
          },
        })
        .then((res) => {
          let resData = res.data;
          if (res.data.status == 200) {
            that.data = resData.data.content;
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    macCoupon() {
      let that = this;
      that
        .$http({
          url: "/app/UserCoupon/is_query_max_coupon",
          method: "post",
          data: {},
        })
        .then((res) => {
          let resData = res.data;
          if (res.data.status == 200) {
            that.maxCouponData = resData.data;
            if (Object.keys(resData.data).length == 0) {
              that.maxCouponCheck = false;
            } else {
              that.maxCouponCheck = true;
            }

            if(that.maxCouponData.amount){
              that.coupounAmount = that.maxCouponData.amount;
              that.effectiveDate = that.maxCouponData.effect_date;
            }
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    //下一步
    rechargeNext() {
      let that = this;
      let number = parseInt(that.recharge.number);
      let type = that.recharge.type;
      if (number === "" || isNaN(number) || number < 100) {
        this.$message.error(that.$t('capital.fillCorrectAmount'));
      } else if (
        type == 6 ||
        type == 7 ||
        type == 8 ||
        type == 9 ||
        type == 10 ||
        type == 11 ||
        type == 12 ||
        type == 13 ||
        type == 14 ||
        type == 17 ||
        type == 18 ||
        type == 19 ||
        type == 20 ||
        type == 21 ||
        type == 22 ||
        type == 3
      ) {
        that.disabled4 = true;
        that
          .$http({
            url: "/app/Recharge/recharge_max_amount",
            method: "post",
            data: {
              type: that.recharge.type,
              id: that.selectedTypeId,
              // recharge_id: that.selectedTypeId,
            },
          })
          .then(function (res) {
            if (res.data.status == 200) {
              that.disabled4 = false;
              let maxamountList = res.data.data;
              if (Object.keys(maxamountList).length > 0) {
                if (number > res.data.data.amount) {
                  (that.Recharge_amount = true),
                    (that.Recharge_Max = res.data.data.message);
                } else {
                  that.recharge_has(number);
                }
              } else {
                that.recharge_has(number);
              }
            } else {
              that.disabled4 = false;
              that.$message.error(that.$t(res.data.msgId));
            }
          })
          .catch(() => {
            that.disabled4 = false;
          });
      } else {
        that.recharge_has(number);
      }
    },
    //设置实名认证
    setReal() {
      let that = this;
      if (that.real.inputReal == "") {
        that.$message.error(that.$t('rechargeau.enterYourRealName'));
      } else if (that.real.inputIdcard == "") {
        that.$message.error(that,$t('rechargeau.enterYourId'));
      } else {
        that
          .$http({
            url: "/app/User/certification",
            method: "post",
            data: {
              name: that.real.inputReal,
              card: that.real.inputIdcard,
              is_simulate: localStorage.getItem('isSimulation') === 'true' ? 1 : 0
            },
          })
          .then(function (res) {
            if (res.data.status == 200) {
              that.$message({
                message: that.$t(res.data.msgId),
                type: "success",
                duration: 1000,
                onClose: function () {
                  that.real.realStatus = false;
                  that.recharge.realStatus = true;
                },
              });
            } else {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      }
    },
    //设置银行卡
    setBank() {
      let that = this;
      if (that.bank.inputBankCode == "") {
        that.$message.error(that.$t('capital.enterBankCardNum'));
      } else if (that.bank.inputBankName == "") {
        that.$message.error(that.$t('capital.nameAccHolder'));
      } else if (that.bank.inputBankAccess == "") {
        that.$message.error(that.$t('capital.enterBankAddress'));
      } else {
        that
          .$http({
            url: "/app/Bank/bind_bank",
            method: "post",
            data: {
              name: that.bank.inputBankName,
              bank_id: that.bank.bankId,
              address: that.bank.inputBankAccess,
              card: that.bank.inputBankCode,
            },
          })
          .then(function (res) {
            if (res.data.status == 200) {
              that.$message({
                message: that.$t(res.data.msgId),
                type: "success",
                duration: 1000,
                onClose: function () {
                  that.bank.bankStatus = false;
                  that.withdrawalData.bankStatus = true;
                  that.getAccountBank();
                },
              });
            } else {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      }
    },
    recharge_has(number) {
      let that = this;
      that.disabled4 = true;
      that
        .$http({
          url: "/app/Recharge/recharge_has",
          method: "post",
          data: {
            number: number,
          },
        })
        .then(function (res) {
          that.disabled4 = false;
          let resData = res.data;
          if (resData.data == 0) {
            that.topUpTransit(number);
          } else {
            that
              .$confirm(
                that.$t('capital.rechargeSubmitMsg'),
                that.$t('capital.hint'),
                {
                  confirmButtonText: that.$t('recharge.contToRecharge'),
                  cancelButtonText: that.$t('recharge.noNewRecharge'),
                  type: "warning",
                  confirmButtonClass: 'dialogConfirm',
                  cancelButtonClass: 'dialogCancel'
                }
              )
              .then(() => {
                that.topUpTransit(number);
              })
              .catch(() => { });
          }
        })
        .catch(() => {
          that.disabled4 = false;
        });
    },
    topUpTransit(number) {
      let that = this;

      if (that.recharge.realStatus) {
        let type = parseInt(that.recharge.type);
        let SelectedType = that.rechargeType.find((o) => o.type == type);
        that.notice_1_1 = SelectedType.notice_1_1;
        that.notice_2_1 = SelectedType.notice_2_1;
        that.notice_2_2 = SelectedType.notice_2_2;
        switch (type) {
          case 6:
            that.disabled4 = true;
            this.$message(that.$t('capital.openPaymentChannel'));
            that
              .$http({
                url: "/app/Recharge/offline_recharge",
                method: "post",
                data: {
                  number: number,
                  type: type,
                  card: "",
                  real_name: "",
                  id: that.selectedTypeId,
                },
              })
              .then(function (res) {
                if (res.data.status == 200) {
                  if (res.data.code == 1) {
                    let resData = res.data.data;
                    that.topUpStatus = true;
                    that.disabled4 = false;

                    that.companyBank.money = resData.receiveOrderAmount;
                    that.companyBank.name = resData.receiveBankAccountName;
                    that.companyBank.card = resData.receiveBankAccountNo;
                    that.companyBank.bank = resData.receiveBankName;
                    let endTime = Number(that.$moment().format("x"));
                    endTime = endTime + 10 * 60 * 1000;
                    that.time.endTime = that
                      .$moment(endTime)
                      .format("YYYY-MM-DD HH:mm:ss");
                  } else if (res.data.code == 2) {
                    that.getTradeChannel();
                    that.disabled4 = false;
                  } else {
                    that.$message.error(that.$t(res.data.msgId));
                    that.disabled4 = false;
                  }
                } else {
                  that.disabledR = false;
                  that.$message.error(that.$t(res.data.msgId));
                }

              })
              .catch(() => {
                that.disabled4 = false;
              });
            break;
          case 7:
            that.disabled4 = true;
            this.$message(that.$t('capital.openPaymentChannel'));
            that
              .$http({
                url: "/app/Recharge/offline_recharge",
                method: "post",
                data: {
                  number: number,
                  type: type,
                  card: "",
                  real_name: "",
                  id: that.selectedTypeId,
                  // recharge_id: that.selectedTypeId,
                },
              })
              .then(function (res) {
                if (res.data.status == 200) {
                  if (res.data.code == 1) {
                    let resData = res.data;
                    that.recharge.url = resData.data.url;
                    that.topUpStatus = true;
                    that.disabled4 = false;
                  } else if (res.data.code == 2) {
                    that.getTradeChannel();
                    that.disabled4 = false;
                  } else {
                    that.$message.error(that.$t(res.data.msgId));
                    that.disabled4 = false;
                  }
                } else {
                  that.disabledR = false;
                  that.$message.error(that.$t(res.data.msgId));
                }

              })
              .catch(() => {
                that.disabled4 = false;
              });
            break;
          case 8:
            that.disabled4 = true;
            this.$message(that.$t('capital.openPaymentChannel'));
            that
              .$http({
                url: "/app/Recharge/offline_recharge",
                method: "post",
                data: {
                  number: number,
                  type: type,
                  card: "",
                  real_name: "",
                  id: that.selectedTypeId,
                  // recharge_id: that.selectedTypeId,
                },
              })
              .then(function (res) {
                if (res.data.status == 200) {
                  if (res.data.code == 1) {
                    let resData = res.data;
                    that.recharge.url = resData.data.url;
                    that.topUpStatus = true;
                    that.disabled4 = false;
                  } else if (res.data.code == 2) {
                    that.getTradeChannel();
                    that.disabled4 = false;
                  } else {
                    that.$message.error(that.$t(res.data.msgId));
                    that.disabled4 = false;
                  }
                } else {
                  that.disabledR = false;
                  that.$message.error(that.$t(res.data.msgId));
                }

              })
              .catch(() => {
                that.disabled4 = false;
              });
            break;
          case 9:
          case 10:
          case 11:
          case 13:
          case 14:
          case 17:
          case 18:
          case 19:
          case 20:
          case 21:
          case 22:
            that.disabled4 = true;
            this.$message(that.$t('capital.openPaymentChannel'));

            // Get user's bank card number
            that
              .$http({
                url: "/app/UserBank/bank_info",
                method: "post",
                data: {},
              })
              .then(function (res) {
                if (res.data.status == 200) {
                  const card = res.data.data.card;

                  that
                    .$http({
                      url: "/app/Recharge/offline_recharge",
                      method: "post",
                      data: {
                        number: number,
                        type: type,
                        card: card,
                        real_name: that.user_realName,
                        id: that.selectedTypeId,
                      },
                    })
                    .then(function (res) {
                      if (res.status == 200) {
                        if (res.data.data.status == 1) {
                          let resData = res.data.data;
                          window.open(resData.url);
                          that
                            .$confirm(that.$t('capital.confirmPaid'), {
                              confirmButtonText: that.$t('trading.sure'),
                              cancelButtonText: that.$t('capitalAccountDetails.cancel'),
                              type: "warning",
                              confirmButtonClass: "dialogConfirm",
                              cancelButtonClass: "dialogCancel"
                            })
                            .then(() => {
                              // that.$router.push('/myaccount/detailed');
                              //on confirm show success message
                              that.$message({
                                message: that.$t('capital.successRechargeApp'),
                                type: "success",
                                onClose: function () {
                                  that.topUpStatus = false;
                                  that.$router.push("/myaccount/detailed");
                                },
                              });
                            })
                            .catch(() => { });
                          that.disabled4 = false;
                        } else {
                          that.disabled4 = false;
                          that.$message.error(res.data.data.msg);
                        }
                      } else {
                        that.disabledR = false;
                        that.$message.error(that.$t(res.data.msgId));
                      }

                    })
                    .catch(() => {
                      that.disabled4 = false;
                      that.$message.error(that.$t(res.data.msgId));

                    });
                } else {
                  that.disabledR = false;
                  that.$message.error(that.$t(res.data.msgId));
                }
              })
              .catch(() => {
                that.disabled4 = false;
              });
            break;
          case 12:
            that.disabled4 = true;
            this.$message(that.$t('capital.openPaymentChannel'));
            that
              .$http({
                url: "/app/Recharge/offline_recharge",
                method: "post",
                data: {

                  number: number,
                  type: type,
                  card: "",
                  real_name: "",
                  id: that.selectedTypeId,
                  // recharge_id: that.selectedTypeId,
                },
              })
              .then(function (res) {
                if (res.data.status == 200) {
                  if (res.data.code == 1) {
                    let resData = res.data.data;
                    that.topUpStatus = true;
                    that.disabled4 = false;
                    that.crypto.money = resData.orderAmount;
                    that.crypto.USDTAmount = resData.orderUSDTAmount;
                    that.crypto.qrCode = resData.qrCodeGenerator;
                    that.crypto.rechargeId = resData.recharge_id;
                    that.qrcode(that.crypto.qrCode);
                    that.CountDown();
                  } else if (res.data.code == 2) {
                    that.getTradeChannel();
                    that.disabled4 = false;
                  } else {
                    that.$message.error(that.$t(res.data.msgId));
                    that.disabled4 = false;
                  }
                } else {
                  that.disabledR = false;
                  that.$message.error(that.$t(res.data.msgId));
                }

              })
              .catch(() => {
                that.disabled4 = false;
              });
            break;
          default:
            that.getCompanyBank();
            break;
        }
      } else {
        
        console.log("sasadasasd")
        let that = this;
        that
          .$http({
            url: "/app/User/user_info",
            method: "post",
            data: {

            },
          })
          .then(function (res) {
            if (res.data.status == 200) {
              that.inputLoginPhone = res.data.data.phone1;
              that.bank.inputBankName = res.data.data.real;
              //实名认证
              if (res.data.data.real != null && that.activeName != "withdraw") {
                //已认证
                that.recharge.realStatus = true;
                that.real.realStatus = false;
              } else {
                //未认证
                that.recharge.realStatus = false;
                that.real.realStatus = true;
              }

              // location.reload();
            }
          }).catch((err) => {
            that.$message.error(that.$t('system.loadFail'));
          })

        // that.real.realStatus = true;
      }
    },
    bankFadeIn() {
      let that = this;
      that
        .$http({
          url: "/app/UserBank/bank_info",
          method: "post",
          data: {

          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.bank.bankList = res.data.data.bank;
            that.bank.bankId = that.bank.bankList[0].id;
                      } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    //获取验证码
    getPayCode() {
      let that = this;
      that.disabled3 = true;
      clearInterval(window.timer2);

      let publicKey = localStorage.getItem("encript_public_key");
      let userPhone = that.inputLoginPhone.toString();
      let inputPhone = that.encryptMessage(userPhone, publicKey);

      that
        .$http({
          url: "/app/SendSms/modifyinfo_code_e",
          method: "post",
          data: {
            info: inputPhone,
            type: 1,
          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.$message({
              message: that.$t(res.data.msgId),
              type: "success",
              duration: 2000,
            });
            var time = 60;
            that.getPayCodeText = time + "s";
            window.timer2 = setInterval(function () {
              time--;
              that.getPayCodeText = time + "s";
              if (time <= 0) {
                clearInterval(window.timer2);
                that.disabled3 = false;
                that.getPayCodeText = that.$t('forgotPassword.getVerificationCode');
              }
            }, 1000);
          } else {
            that.$message.error(that.$t(res.data.msgId));
            that.disabled3 = false;
          }
        });
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    },
    //修改登录密码 操作
    setPayPass() {
      let that = this;
      if (that.inputPayCode == "") {
        that.$message.error(that.$t('modifyWithdrawPassword.verificationLable'));
      } else if (that.inputPayPass == "") {
        that.$message.error(that.$('modifyLoginPassword.enterPasswordLable'));
      } else if (that.inputPayConf == "") {
        that.$message.error(that.$t('capital.enterConfirmationPw'));
      } else if (that.inputPayConf != that.inputPayPass) {
        that.$message.error(that.$t('capital.inconsistentPw'));
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let inputPassWord = that.encryptMessage(that.inputPayPass, publicKey);
        let inputPassWordCon = that.encryptMessage(
          that.inputPayConf,
          publicKey
        );
        that
          .$http({
            url: "/app/User/modify_pay_e",
            method: "post",
            data: {
              password: inputPassWord,
              confirm: inputPassWordCon,
              code: that.inputPayCode,
              phone: that.inputLoginPhone
            },
          })
          .then(function (res) {
            if (res.data.status == 200) {
              that.$message({
                message: that.$t(res.data.msgId),
                type: "success",
                duration: 1000,
                onClose: function () {
                  that.withdrawalState = false;
                },
              });
            } else {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      }
    },
    //取消支付密码
    emptyPayPass() {
      let that = this;
      that.inputPayCode = "";
      that.inputPayConf = "";
      that.inputPayPass = "";
      that.withdrawalState = false;
    },
    //充值
    onRecharge() {
      let that = this;
      that.recharge.url = "";
      let number = parseInt(that.recharge.number);
      let type = parseInt(that.recharge.type);
      if (number === "" || isNaN(number)) {
        this.$message.error(that.$t('capital.fillCorrectAmount'));
      }
      // let card = that.recharge.card.toString();
      if (type === "" || isNaN(type)) {
        this.$message.error(that.$t('capital.chooseRechargeMethod'));
      } else if (type === 6 || type === 7 || type === 8) {
        that.$message({
          message: that.$t('capital.successRechargeApp'),
          type: "success",
          onClose: function () {
            that.topUpStatus = false;
            that.$router.push("/myaccount/detailed");
            that.time.endTime = 0;
          },
        });
      } else if (type === 12) {
        that.disabledR = true;
        that
          .$http({
            url: "/app/Recharge/recharge_sure",
            method: "post",
            data: {
              id: that.crypto.rechargeId,
            },
          })
          .then(function (res) {
            if (res.data.status == 200) {
              if (res.data.code == 1) {
                that.$message({
                  message: that.$t(res.data.msgId),
                  type: "success",
                  onClose: function () {
                    that.topUpStatus = false;
                    that.$router.push("/myaccount/detailed");
                    that.disabledR = false;
                  },
                });
              } else if (res.data.code == 2) {
                that.getTradeChannel();
                that.disabledR = false;
              } else {
                that.$message.error(that.$t(res.data.msgId));
                that.disabledR = false;
              }
            } else {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      } else {
        that.disabledR = true;
        that
          .$http({
            url: "/app/Recharge/offline_recharge",
            method: "post",
            data: {
              number: number,
              type: type,
              card: that.companyBank.card,
              real_name: "",
              id: that.selectedTypeId,
              // recharge_id: that.selectedTypeId,
            },
          })
          .then(function (res) {
            if (res.data.status == 200) {
              if (res.data.code == 1) {
                that.$message({
                  message: that.$t(res.data.msgId),
                  type: "success",
                  onClose: function () {
                    that.topUpStatus = false;
                    that.$router.push("/myaccount/detailed");
                    that.disabledR = false;
                  },
                });
              } else if (res.data.code == 2) {
                that.getTradeChannel();
                that.disabledR = false;
              } else {
                that.$message.error(that.$t(res.data.msgId));
                that.disabledR = false;
              }
            } else {
              that.disabledR = false;
              that.$message.error(that.$t(res.data.msgId));
            }

          })
          .catch(() => {
            that.disabledR = false;

          });
      }
    },
    //获取公司银行卡
    getCompanyBank() {
      let that = this;
      that
        .$http({
          url: "/app/Recharge/recharge_info",
          method: "post",
          data: {
            number: parseInt(that.recharge.number),
          },
        })
        .then(function (res) {
          let resData = res.data.data;
          if (res.data.status == 200) {
            if (that.recharge.type == 8) {
              that.companyBank.card = that.$t('capital.contactOnlineCustomerSer');
            } else {
              that.companyBank = res.data.data.bank;
            }

            /*that.ali_isactive = Number(resData.ali_isactive);
            that.wechat_isactive = Number(resData.ali_isactive);
            if (that.ali_isactive === 1){
              that.ali_pay = resData.ali_pay;
            }
            if (that.wechat_isactive){
              that.we_chat_pay = resData.we_chat_pay;
            }*/

            that.$message({
              message: that.$t('capital.openPaymentChannel'),
              duration: 500,
              onClose: function () {
                that.topUpStatus = true;
              },
            });
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    //复制
    handleCopy(copy) {
      let that = this;
      let typeName = copy;
      let oInput = document.createElement("input");
      oInput.value = typeName;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$message({
        message: that.$t('agencyLink.copySuccess'),
        type: "success",
      });
      oInput.remove();
    },
    //获取账户银行卡
    getAccountBank() {
      let that = this;
      that
        .$http({
          url: "/app/UserBank/accountbank",
          method: "post",
          data: {

          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.bankCardList = res.data.data;
            if (that.bankCardList.length > 0) {
              that.withdrawalData.account = that.bankCardList[0].account;
              that.withdrawalData.card = that.bankCardList[0].card;
              that.withdrawalData.name = that.bankCardList[0].name;
              that.withdrawalData.address = that.bankCardList[0].address;
              that.withdrawalData.isWithdrawalData = true; //if bank information have, set showbandcard popup not to show
            } else {
              that.withdrawalData.isWithdrawalData = false; //if bank information have, set showbandcard popup to show
            }
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        })
        .finally(() => {
          that.showBankCardPopup();
        });
    },
    handleClick(tab, event) {
      let that = this;
      switch (tab.name) {
        case "withdraw":
          //get withdraw bank information everytime come to withdraw tab
          that.getConfig();

          // if (that.withdrawalData.isWithdrawalData) {
          // that
          //   .$confirm("请先设置提现银行卡才能提现", "提示", {
          //     confirmButtonText: "确定",
          //     cancelButtonText: "取消",
          //     type: "warning",
          //   })
          //   .then(() => {
          //     that.bank.bankStatus = true;
          //   })
          //   .catch(() => {
          //     this.$message({
          //       type: "info",
          //       message: "已取消删除",
          //     });
          //   });
          // }
          break;
      }
    },
    //多银行卡选择
    handleBankCard(row) {
      let that = this;
      that.withdrawalData.account = row.account;
      that.withdrawalData.card = row.card;
      that.withdrawalData.name = row.name;
      that.withdrawalData.address = row.address;
      that.bankCardState = false;
    },
    //获取用户信息
    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/app/User/user",
          method: "post",
          data: {

          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.withdrawalData.cash = res.data.data.cash;
            that.trade_channel_status = res.data.data.trade_channel_status;
            that.user_realName = res.data.data.real;
            if (that.trade_channel_status == 1) {
              that.getTradeChannel();
            }
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    // get withdraw free precentage
    getWithdrawChannelInfo() {
      let that = this;
      that
        .$http({
          url: "/app/Withdraw/withdraw_channel",
          method: "post",
          data: {

          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.withdraw_fee_percentage =
              res.data.data.withdraw_fee_percentage;
            that.withdraw_fee_min = res.data.data.withdraw_fee_min;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },

    withdraw_has() {
      let that = this;
      let type = parseInt(that.withdrawalData.type);
      if(type == 2 && that.withdrawalData.confirmChecked == false){
        that.$message.error("请核对您的Gxpay ID 后再确认提现操作");
      }else{
        let number = that.withdrawalData.money;
        that
          .$http({
            url: "/app/Withdraw/withdrawHas",
            method: "post",
            data: {
              number: number,
            },
          })
          .then(function (res) {
            let resData = res.data.data;
            if (resData == 0) {
              that.WithdrawPopup();
              // that.withdrawal();
              // that.topUpTransit(number);
            } else {
              that
                .$confirm(
                  "\n" +
                  that.$t('capital.submitWithdrawlMsg'),
                  that.$t('capital.hint'),
                  {
                    confirmButtonText: that.$t('withdraw.contToWithdraw'),
                    cancelButtonText: that.$t('withdraw.noNewWithdraw'),
                    confirmButtonClass: "dialogConfirm",
                    cancelButtonClass: "dialogCancel"
                  }
                )
                .then(() => {
                  that.WithdrawPopup();
                  // that.topUpTransit(number);
                })
                .catch(() => { });
            }
          });
      }
    },
    WithdrawPopup() {
      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/sysconfig/action",
          method: "post",
          data: {
            action: "withdraw_popup",
          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.popupStatus = res.data.data.is_withdraw_popup;
            that.timbaoAnulaizedInterestRate =
              res.data.data.timebao_annualized_interest_rate;
            that.timebaoRate = res.data.data.timebao_rate;
            that.secondWithdrawalPopup();
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    secondWithdrawalPopup() {
      let that = this;
      if (that.popupStatus == 1) {
        that
          .$confirm(
            that.$t('capital.msgTransferEarn') +
            that.timebaoRate +
            that.$t('capital.stockTradMsg') +
            that.timbaoAnulaizedInterestRate +
            "%",
            {
              title: that.$t('withdraw.friendlyReminder'),
              confirmButtonText: that.$t('withdraw.timebaoright'),
              cancelButtonText: that.$t('withdraw.timebaoleft'),
              confirmButtonClass: "dialogConfirm",
              cancelButtonClass: "dialogCancel"
            }
          )
          .then(() => {
            that.withdrawal();
          })
          .catch(() => {
            that.$router.push("/myaccount/timebao");
          });
      } else {
        that.withdrawal();
      }
    },
    //提现
    withdrawal() {
      let that = this;
      let loadingInstance = Loading.service({ fullscreen: true });
        let number = that.withdrawalData.money;
        let password = that.withdrawalData.password;
        let name = that.withdrawalData.name;
        let card = that.withdrawalData.card;
        let id = that.selectedWithdrawTypeId;
        let type = parseInt(that.withdrawalData.type);
        switch (type) {
        case 2:
        if(that.withdrawalData.confirmChecked == false){
          that.$message.error("请核对您的Gxpay ID 后再确认提现操作");
        }else{
          that
            .$http({
              url: "/app/Withdraw/withdraw",
              method: "post",
              data: {
                number: number,
                password: password,
                id: id,
                type: type,
                gxpay_id:that.withdrawalData.gxpay_id
              },
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.status == 200) {
                if (res.data.data.code == 1) {
                  that.$message({
                    message: that.$t(res.data.msgId),
                    type: "success",
                    onClose: function () {
                      that.$router.push("/myaccount/detailed");
                    },
                  });
                } else if (res.data.data.code == 2) {
                  that.getTradeChannel();
                } else {
                  that.$message.error(that.$t(res.data.msgId));
                }
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
              setTimeout(() => {
                  loadingInstance.close();
                }, 500);
            });
        }
          break;
          default:
          if (that.withdrawalData.bankStatus) {

            that
          .$http({
            url: "/app/Withdraw/withdraw",
            method: "post",
            data: {
              number: number,
              password: password,
              name: name,
              card: card,
              id: id,
              type: type,
            },
          })
          .then(function (res) {
            let resData = res.data;
            if (res.data.status == 200) {
              if (res.data.data.code == 1) {
                that.$message({
                  message: that.$t(res.data.msgId),
                  type: "success",
                  onClose: function () {
                    that.$router.push("/myaccount/detailed");
                  },
                });
              } else if (res.data.data.code == 2) {
                that.getTradeChannel();
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            } else {
              that.$message.error(that.$t(res.data.msgId));
            }
            setTimeout(() => {
                loadingInstance.close();
              }, 500);
          });
        }
        else {
        that.bank.bankStatus = true;
      }
      break;
      } 
      
    },
    getRechargetype() {
      let that = this;
      that
        .$http({
          url: "/app/UserAccount/account",
          method: "post",
          data: {
            action: "rechargetype",
            app_version: version,
          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            let resData = res.data;
            let rechargeType = resData.data.rechargeType;

            rechargeType.forEach((element, index) => {
              if (element.is_default == 1) {
                that.recharge.type = element.type;
                that.radio = index;
              }
            })

            let type = parseInt(that.recharge.type);
            let SelectedType = rechargeType.find((o) => o.type == type);

            that.notice_1_1 = SelectedType.notice_1_1;
            that.notice_2_1 = SelectedType.notice_2_1;
            that.notice_2_2 = SelectedType.notice_2_2;
            that.selectedTypeId = SelectedType.id;
            that.rechargeType = rechargeType;
            that.auto_fill_amounts =SelectedType.auto_fill_amounts;
            const jsonString = that.auto_fill_amounts.replace(/'/g, '"');
            that.auto_fill_amounts = JSON.parse(jsonString);
      that.auto_fill_amounts.length>0?that.isAutoAmounts=true:that.isAutoAmounts=false;
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    getWithdrawtype() {
      let that = this;
      that
        .$http({
          url: "/app/Withdraw/withdraw_type",
          method: "post",
          data: {
            app_version: version,
          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            let resData = res.data;
            let withdraweType = resData.data.withdrawTypes;

            withdraweType.forEach((element, index) => {
              if (element.is_default == 1) {
                that.withdrawalData.type = element.type;
                that.radioW = index;
              }
            })

            let type = parseInt(that.withdrawalData.type);
            let SelectedType = withdraweType.find((o) => o.type == type);
            that.notice_1_10 = SelectedType.notice1;
            that.notice_2_1 = SelectedType.notice_2_1;
            that.notice_2_2 = SelectedType.notice_2_2;
            that.selectedTypeId = SelectedType.id;
            that.selectedWithdrawTypeId = SelectedType.id;
            that.withdraweType = withdraweType;
            that.auto_fill_amounts_withdraw = SelectedType.auto_fill_amounts;
            const jsonString = that.auto_fill_amounts_withdraw.replace(/'/g, '"');
      that.auto_fill_amounts_withdraw = JSON.parse(jsonString);
      that.auto_fill_amounts_withdraw.length>0?that.isAutoAmountsWithdraw=true:that.isAutoAmountsWithdraw=false;
            that.selected_type=SelectedType.type;          
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    //去资金详细
    goDetailed() {
      this.$router.push({
        path: "/myaccount/detailed",
      });
    },
    //获取个人信息
    getConfig() {
      let that = this;
      that
        .$http({
          url: "/app/User/user_info",
          method: "post",
          data: {

          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.inputLoginPhone = res.data.data.phone1;
            that.bank.inputBankName = res.data.data.real;
            //实名认证
            if (res.data.data.real != null && that.activeName != "withdraw") {
              //已认证
              that.recharge.realStatus = true;
            } else {
              //未认证
              that.recharge.realStatus = false;
            }

            if (res.data.data.real != null) {
              that.realNameEditStatus = true;
            } else {
              that.realNameEditStatus = false;
            }

            if (res.data.data.withdrawal == 0 && that.activeName == "withdraw") {
              that
                .$confirm(that.$t('withdraw.withdrawPasswordNotset'), {
                  confirmButtonText: that.$t('trading.sure'),
                  cancelButtonText: that.$t('capitalAccountDetails.cancel'),
                  type: "warning",
                  confirmButtonClass: "dialogConfirm",
                  cancelButtonClass: "dialogCancel"
                })
                .then(() => {
                  that.withdrawalState = true;
                })
                .catch(() => {
                  that.getAccountBank();
                });
            } else {
              that.getAccountBank();
            }
            
            if (res.data.data.bank != 0 && that.activeName == "withdraw") {
              //已绑定
              that.withdrawalData.bankStatus = true;
            } else {
              //未绑定
              that.withdrawalData.bankStatus = false;
            }
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        }).catch(() => {
            that.$message.error(that.$t('system.loadFail'));
        });
    },
    qrcode(url) {
      setTimeout(function () {
        document.getElementById("qrcode").innerHTML = "";
        let qrcode = new QRCode(document.getElementById("qrcode"), {
          width: 150,
          height: 150,
          text: url, // 二维码地址
        });
      }, 1500);
    },
    CountDown() {
      clearInterval(this.interVal);
      var duration = this.countDownTime;
      if (!isNaN(duration)) {
        var timer = duration,
          hours,
          minutes,
          seconds;
        this.interVal = setInterval(function () {
          hours = parseInt((timer / 3600) % 24, 10);
          minutes = parseInt((timer / 60) % 60, 10);
          seconds = parseInt(timer % 60, 10);

          hours = hours < 10 ? "0" + hours : hours;
          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;

          $("#countDown").html(hours + " : " + minutes + " : " + seconds);

          if (--timer < 0) {
            timer = duration;
            clearInterval(this.interVal);
          }
        }, 1000);
      }
    },
    //show add bankcard popup
    showBankCardPopup() {
      let that = this;
      if (
        that.activeName == "withdraw" &&
        !that.withdrawalData.isWithdrawalData
      ) {
        that
          .$confirm(that.$t('withdraw.bankNotBound'), that.$t('capital.hint'), {
            confirmButtonText: that.$t('trading.sure'),
            cancelButtonText: that.$t('capitalAccountDetails.cancel'),
            confirmButtonClass: "dialogConfirm",
            cancelButtonClass: "dialogCancel",
            type: "warning",
          })
          .then(() => {
            that.bank.bankStatus = true;
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: that.$t('capital.unDeleted'),
            });
          });
      }
    },
    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      that
        .$http({
          url: "/app/User/trade_popup",
          method: "post",
          data: {
            
          },
        })
        .then(function (res) {
          if (res.data.status == 1) {
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
          }
        });
    },
    handleTradePopupClose(done) {
      this.$router.push("/myaccount/rechange");
    },
    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/app/TradeChannalLog/modify_trade_status",
          method: "post",
          data: {
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.$message({
              message: that.$t(res.data.msgId),
              type: "success",
              duration: 1000,
            });
            that.showTradeChannelPopup = false;
            that.trade_channel_status = 0;
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    getServerUrl() {
      let that = this;
      that.$http({
        url: "/app/Home/server_url",
        method: "get",
        data: {

        },
        transformRequest: [(data) => JSON.stringify(data)]
      })
        .then(ret => {
          let resData = ret.data;
          // if (resData.code === 1) {
          window.open(resData.data, '_blank ');

          // }
        });
    },
    changeInstructions(index) {
      let that = this;
      let SelectedType = that.rechargeType[index];
      that.recharge.type = SelectedType.type;
      that.notice_1_1 = SelectedType.notice_1_1;
      that.notice_2_1 = SelectedType.notice_2_1;
      that.notice_2_2 = SelectedType.notice_2_2;
      that.selectedTypeId = SelectedType.id;
      that.auto_fill_amounts =SelectedType.auto_fill_amounts;
      const jsonString = that.auto_fill_amounts.replace(/'/g, '"');
            that.auto_fill_amounts = JSON.parse(jsonString);
            console.log(that.auto_fill_amounts);
console.log(that.auto_fill_amounts.includes(' '));
            that.auto_fill_amounts.length>0?that.isAutoAmounts=true:that.isAutoAmounts=false;
      that.recharge.number='';
    },
    handleAmount(amount){
       let that = this;
       that.recharge.number =amount;
    },
    changeWithdrawInstructions(index) {
      let that = this;
      let SelectedType = that.withdraweType[index];
      console.log('hi',SelectedType);
      that.withdrawalData.type = SelectedType.type;
      that.notice_1_10 = SelectedType.notice1;
      that.notice_2_1 = SelectedType.notice_2_1;
      that.notice_2_2 = SelectedType.notice_2_2;
      that.selectedWithdrawTypeId = SelectedType.id;
      that.auto_fill_amounts_withdraw = SelectedType.auto_fill_amounts;
      const jsonString = that.auto_fill_amounts_withdraw.replace(/'/g, '"');
      that.auto_fill_amounts_withdraw = JSON.parse(jsonString);
      that.auto_fill_amounts_withdraw.length>0?that.isAutoAmountsWithdraw=true:that.isAutoAmountsWithdraw=false;
      that.withdrawalData.money = '';
      that.selected_type=SelectedType.type;
      that.withdrawalData.checked = false;
      that.getGxpayId();

    },
    handleWithdrawAmount(amount){
       let that = this;
       that.withdrawalData.money =amount;
     },
    getGxpayId() {
      let that = this;
      that
          .$http({
              url: "/app/Recharge/gxpay_thirdparty_digital_currency",
              method: "POST",
              data: {},
          })
          .then((ret) => {
              let resData = ret.data;
              if (resData.status == 1) {
                if(resData.data.user == true){
            
                  that.withdrawalData.gxpay_id = resData.data.numberId;
          }else{
            if(that.selected_type==2){
              window.open(resData.data.homeUrl,"_blank");
            that.$router.push("/myaccount/rechange"); 
            }

          }
              }
          });
    },
  },
  mounted() {
    let that = this;
    // this.getCompanyBank();
    this.getUserinfo();
    this.getConfig();
    that.getRechargetype();
    // this.getAccountBank();
    this.getData();
    this.macCoupon();
    that.bankFadeIn();
    this.getWithdrawChannelInfo();
    that.getWithdrawtype();
    that.getGxpayId();
    let active = that.$route.query.active;
    if (active) {
      that.activeName = active;
    }
  },
};
</script>

<style scoped>
.el-button.is-round{
   padding :10px !important;
   width:85px !important;
 }
.withdrawRadio {
  width: 100%;
  margin-left: 0 !important;
}
.title {
  font-weight: bold;
  font-size: 16px;
}

.assist {
  font-size: 14px;
  line-height: 25px;
}

.weigth {
  font-weight: bold;
}

.recharge-img {
  text-align: center;
}

.hint {
  line-height: 1.5;
  width: 90%;
  margin: 0 auto 40px;
  color: red;
}
.notice-hint {
  line-height: 1.5;
  width: 90%;
  margin: 0px 28px 26px;
}

.rechargeRadio {
  width: 100%;
  margin-left: 0 !important;
}

.headerTopBg {
  background-color: #ffffff;
  border-radius: 8px;
  margin-bottom: 20px;
  padding: 18px 20px;
}

#types>>>.el-radio__input.is-checked+.el-radio__label {
  color: var(--baseColor) !important;
}
#types>>>.el-radio__input.is-checked .el-radio__inner {
  border-color: var(--baseColor) !important;
  background: var(--baseColor) !important;
}
#types>>>.el-radio.is-bordered.is-checked {
  border-color: var(--baseColor) !important;
}
#amountInput>>>.el-input__inner:focus {
  border-color: var(--baseColor) !important;
}
.el-message-box__btns button:nth-child(2) {
  background-color: var(--baseColor) !important;
}
.dialog-cancel:hover {
  color: var(--baseColor) !important;
  border-color: var(--baseColor) !important;
  background-color: #fff !important;
}

.confirmCheckedBox {
   margin-left: 580px;
   margin-top: -32px;
 }
</style>
<style>
#thirdPartyPopup .el-dialog__header {
  display: none;
}

#thirdPartyPopup .el-dialog__body {
  padding: 20px 20px;
}
#thirdPartyPopup .el-dialog__footer {
  padding: 0px 20px 20px;
}

#thirdPartyPopup .el-dialog {
  margin-top: 0 !important;
  top: 40%;
}
.crypto_qrcode {
  width: 153px;
  margin: 25px 0;
}
.el-dialog__body {
  padding: 0px 20px !important;
}

.tradingChannelPop .el-dialog__body {
  padding: 0px 20px;
}

#rechargeWithTab .el-tabs__item.is-active {
  color: var(--baseColor);
  font-weight: 700;
}

#rechargeWithTab .el-tabs__active-bar {
  height: 4px;
  border-radius: 5px;
  background-color: var(--baseColor);
}
</style>


// WEBPACK FOOTER //
// src/components/capital.vue